import { RenderContext } from '@eventbrite/checkout-fairy-api';
import { EventStatus } from '../../../constants/eventStatus';

export const getFirstAvailableDate = (
    eventDates: RenderContext['eventDates'],
) =>
    eventDates?.find(
        (eventDate) => eventDate.availability === EventStatus.available,
    );
